export const SET_MAINTENANCE_SCHEDULE_READ = 'MAINTENANCE/SET_MAINTENANCE_SCHEDULE_READ';
export const SET_MAINTENANCE_STATUS = 'MAINTENANCE/SET_MAINTENANCE_STATUS';
